module.exports = __webpack_public_path__ + "img/card-b1.fd08bb5e.jpg";